import '../styles/main.scss';
import { initInputs } from '@components/inputs';
import { initAccordions } from '@components/accordions';
import { initModals } from '@components/modals';
import { initVideoControls } from '@components/media';
import { initExternalCartSync } from '@services/cart-external-sync';

(() => {
  initInputs();
  initAccordions();
  initModals();
  initVideoControls();
  initExternalCartSync();
})();
